import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useMatricula from "../hooks/useMatricula";
import actuaDatos from "../assets/iconos/actualizarDatos.svg";
import reglamentos from "../assets/iconos/reglamentos.svg";
import seguro from "../assets/iconos/seguro.svg";
import horario from "../assets/iconos/horario.svg";
import pago from "../assets/iconos/pago.svg";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";
import useAuth from "../hooks/useAuth";

const ProcesoMatricula = () => {
  let location = useLocation();
  let { procesoMatricula, obtenerDatosEstudiante } = useMatricula();
  let {pasoProcesoM,setPasoProcesoM}=useProcesoMatricula();
  const {listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  useEffect(() => { 
  }, [location]);
 

  const { pathname } = location;

  let validateUseProcesoMatri = (pag) => {

    const arrayPasos = [1,2,3,4,5,6];

    let resultado;
    if (arrayPasos.slice(0,pasoProcesoM).length==0) {
       if ((pasoProcesoM+1) == pag) {
        
        resultado= "active"
       }
    }else{

      let pasos = arrayPasos.slice(0,pasoProcesoM)
      pasos.map((data)=>{
         if(data == (pag<=pasoProcesoM)){
          
          resultado = "completed"
         }
      })

      if ((pasoProcesoM+1) == pag) {
         
        resultado = "active"
      }

    }

    return resultado;
     
  };

  useEffect(() => {
  
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        home_proceso_matricula: obtenerLabelEtiqueta(
          "lbl_home_proceso_matricula",
          listadoEtiquetas
        ),
        global_actualizacion_datos: obtenerLabelEtiqueta(
          "lbl_global_actualizacion_datos",
          listadoEtiquetas
        ),
        global_reglamento_estudio: obtenerLabelEtiqueta(
          "lbl_global_reglamento_estudio",
          listadoEtiquetas
        ),
        global_msj_seguro: obtenerLabelEtiqueta(
          "lbl_global_msj_seguro",
          listadoEtiquetas
        ),
        global_horario: obtenerLabelEtiqueta(
          "lbl_global_horario",
          listadoEtiquetas
        ),
        global_pago: obtenerLabelEtiqueta(
          "lbl_global_pago",
          listadoEtiquetas
        ),
        home_confirmacion: obtenerLabelEtiqueta(
          "lbl_home_confirmacion",
          listadoEtiquetas
        ),

      });
    }
  }, [listadoEtiquetas]);

  const { home_proceso_matricula,
    global_actualizacion_datos,
    global_reglamento_estudio,
    global_msj_seguro,
    global_horario,
    global_pago,
    home_confirmacion} = etiquetas
  

  return (
    <div className="card mt-3 shadow-sm ">
      <div className="card-body">
        {pathname == "/" && (
          <>
            <div className="home-title">
              <h6 className="text-uppercase">{home_proceso_matricula}</h6>
              <div className="separator"></div>
            </div>
          </>
        )}

        {pathname == "/matricula" && (
          <>
            <div className="step-mobile d-block  d-md-none d-lg-none animate-fade animate__animated animate__fadeIn">
              
                
                {(pasoProcesoM+1) == 1 && (
                    <div className="rounded-icon icon-s1  va-middle">
                      <img src={actuaDatos} />
                    </div>
                    
                  )}
                { (pasoProcesoM+1) == 2  && (
                    <div className="rounded-icon icon-s1  va-middle"> 
                    <img src={reglamentos} />
                    </div>
                    
                  )}
                {(pasoProcesoM+1) == 3 && 
                  <div className="rounded-icon icon-s1  va-middle"> 
                   <img src={seguro} /> 
                  </div>
                  
                  }
                {(pasoProcesoM+1) == 4 && (
                  <div className="rounded-icon icon-s1  va-middle">
                    <img src={horario} /> 
                  </div>
                  
                )}
                {(pasoProcesoM+1) == 5 && (
                  <div className="rounded-icon icon-s1  va-middle"> 
                    <img src={pago} />
                  </div>
                  
                )}
                {(pasoProcesoM+1) == 6 && 
                  <div className="va-middle"> 
                  <div className="success-animation">
                  <svg
                    className="checkmark-animation"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <circle
                      className="checkmark__circle"
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    ></circle>
                    <path
                      className="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    ></path>
                  </svg>
                </div>
                </div>
                }
              
              <h5 className="text-uppercase fw-medium animate-fade animate__animated animate__fadeIn">
                {(pasoProcesoM+1) == 1 &&
                  `1. ${global_actualizacion_datos}`}
                {(pasoProcesoM+1) == 2 &&
                  `2. ${global_reglamento_estudio}`}
                {(pasoProcesoM+1) == 3 &&
                  `3. ${global_msj_seguro}`}
                {(pasoProcesoM+1) == 4 && `4. ${global_horario}`} 
                {(pasoProcesoM+1) == 5 && `5. ${global_pago}`} 
                {(pasoProcesoM+1) == 6 &&
                  `6. ${home_confirmacion}`} 
              </h5>
            </div>
          </>
        )}

        <ul className="steps-icon bg-transparent ">
          <li className={validateUseProcesoMatri(1)}>
            <span className="step-round">
              <i className="far fa-edit"></i>
            </span>
            <div className="text-center step-title">
              1. <span>{global_actualizacion_datos}</span>{" "}
            </div>
          </li>
          <li className={validateUseProcesoMatri(2)}>
            <span className="step-round">
              <i className="far fa-file"></i>
            </span>
            <div className="text-center  step-title">
              2. <span>{global_reglamento_estudio}</span>
            </div>
          </li>
          <li className={validateUseProcesoMatri(3)}>
            <span className="step-round">
              <i className="far fa-heart"></i>
            </span>
            <div className="text-center step-title">
              3. <span>{global_msj_seguro}</span>{" "}
            </div>
          </li>
          <li className={validateUseProcesoMatri(4)}>
            <span className="step-round">
              <i className="far fa-calendar"></i>
            </span>
            <div className="text-center step-title">
              4. <span>{global_horario}</span>
            </div>
          </li>
          <li className={validateUseProcesoMatri(5)}>
            <span className="step-round">
              <i className="far fa-credit-card"></i>
            </span>
            <div className="text-center step-title">
              5. <span>{global_pago}</span>
            </div>
          </li>
          <li className={validateUseProcesoMatri(6)}>
            <span className="step-round">
              <i className="far fa-check"></i>
            </span>
            <div className="text-center step-title">
              6. <span>{home_confirmacion}</span>
            </div>
          </li>
        </ul>
        {pathname == "/" && (
          <ul className="steps-list-text">
            <li className={validateUseProcesoMatri(1)}>
              <p className="mb-0">1. {global_actualizacion_datos}</p>
            </li>
            <li className={validateUseProcesoMatri(2)}>
              <p className="mb-0">2. {global_reglamento_estudio}</p>
            </li>
            <li className={validateUseProcesoMatri(3)}>
              <p className="mb-0">3. {global_msj_seguro}</p>
            </li>
            <li className={validateUseProcesoMatri(4)}>
              <p className="mb-0">4. {global_horario}</p>
            </li>
            <li className={validateUseProcesoMatri(5)}>
              <p className="mb-0">5. {global_pago}</p>
            </li>
            <li className={validateUseProcesoMatri(6)}>
              <p className="mb-0">6. {home_confirmacion}</p>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default ProcesoMatricula;
